var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_4397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78271 3C6.3263 3 4.33496 4.97942 4.33496 7.4211C4.33496 9.86279 6.3263 11.8423 8.78271 11.8423C11.2391 11.8423 13.2305 9.86284 13.2305 7.4211C13.2305 4.97937 11.2392 3 8.78271 3ZM8.77441 10.6778C6.9813 10.6778 5.52768 9.21684 5.52768 7.41467C5.52768 5.6125 6.98135 4.1515 8.77441 4.1515C10.5675 4.1515 12.0211 5.61246 12.0211 7.41467C12.0211 9.21688 10.5675 10.6778 8.77441 10.6778Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0095 20.0424L2.85514 20.096C2.85514 20.096 0.956074 20.3222 1.73572 18.3432C2.51536 16.3642 3.46644 14.6722 5.98357 14.2552C9.30189 13.7055 11.091 13.7055 13.9296 15.2447",
    stroke: "#E5E7EB",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6577 13.0245L19.9537 11.6619C19.9537 11.6619 20.6467 10.8656 21.4563 11.6252C21.8936 12.0355 22.186 12.4467 22.3625 12.7382C22.4307 12.8508 22.4612 12.9823 22.4497 13.1135C22.4381 13.2446 22.3851 13.3687 22.2983 13.4678L20.6367 15.3632L16.9404 19.1265C16.8344 19.2345 16.7021 19.3129 16.5565 19.3542L13.9206 20.1013C13.7959 20.1367 13.6797 20.0239 13.7113 19.8982L14.3272 17.4517C14.3551 17.3408 14.4128 17.2397 14.494 17.1591L18.6577 13.0245Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 14.1499L19.5122 12.2246L18.7051 13.0317L20.6304 14.957L21.4375 14.1499Z",
    fill: "#E5E7EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_4397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 17.6566,
    fill: "white",
    transform: "translate(1 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.ce6b270d9915b9094a2a1f93c9ced1bd.svg";
export { ForwardRef as ReactComponent };